import { createAction } from '@reduxjs/toolkit';
import { TPVoteCommentsList, TPVoteItem } from './api';

export const fetchVoteItem =
  createAction<TPVoteItem, 'vote/fetchVoteItem'>('vote/fetchVoteItem');
export const fetchVoteCommentsList = createAction<
  TPVoteCommentsList,
  'vote/fetchVoteCommentsList'
>('vote/fetchVoteCommentsList');
